module.exports = __webpack_public_path__ + "img/117.3.4e56a12e.png";